module.exports = 
	phoneValidator: (message = 'validation.phone') ->
		(v) ->
			regex = /^(\+\d+|\d+)$/
			phone = String(v)
			{ valid: !!regex.test(phone), message }
	
	emailValidator: (message = 'validation.login') ->
		(v) ->
			regex = /^[a-z0-9._+-]+@[a-z0-9._-]+\.[a-z0-9._-]+$/
			email = String(v)
			{ valid: !!regex.test(email), message }

	requiredFieldValidator: (message = 'validation.required_field') ->
		(v) ->
			{ valid: !!String(v), message }